<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="profileChoiceSurveyUsers">
            <template v-slot:options>
                <div class="apprentice-group-table-actions">
                    <b-button
                        class="btn-download"
                        variant="primary"
                        target="_blank"
                        :href="routes.managementProfileChoiceSurveyDownload(profileChoiceSurveyIn.id)">
                        {{ $t('management.download_excel') }}
                    </b-button>
                </div>
            </template>

            <template v-slot:cell(first_choice)="row">
                <span v-if="row.item.hasFirstChoice">{{ row.item.firstChoiceString }}</span>
            </template>

            <template v-slot:cell(second_choice)="row">
                <span v-if="row.item.hasSecondChoice">{{ row.item.secondChoiceString }}</span>
            </template>

            <template v-slot:cell(third_choice)="row">
                <span v-if="row.item.hasThirdChoice">{{ row.item.thirdChoiceString }}</span>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-profile-choice-show-component',
    props: ['profileChoiceSurveyIn'],
    data() {
        return {
            profileChoiceSurveyUsers: this.profileChoiceSurveyIn.profile_choice_survey_users.map((surveyUser) => {
                let values = {
                    hasFirstChoice: false,
                    firstChoiceString: null,
                    hasSecondChoice: false,
                    secondChoiceString: null,
                    hasThirdChoice: false,
                    thirdChoiceString: null,
                };

                const first_choice = surveyUser.profile_choices.find((item) => item.choice === 1);
                if (first_choice) {
                    values.hasFirstChoice = true;
                    values.firstChoiceString = first_choice.course.name;
                }

                const second_choice = surveyUser.profile_choices.find((item) => item.choice === 2);
                if (second_choice) {
                    values.hasSecondChoice = true;
                    values.secondChoiceString = second_choice.course.name;
                }

                const third_choices = surveyUser.profile_choices
                    .filter((item) => item.choice === 3)
                    .map((item) => item.course.name);
                if (third_choices) {
                    values.hasThirdChoice = true;
                    values.thirdChoiceString = third_choices.join(', ');
                }

                return { ...values, ...surveyUser };
            }),
            fields: [
                {
                    key: 'user.name',
                    label: this.$t('common.first_name'),
                    sortable: true,
                },
                {
                    key: 'user.surname',
                    label: this.$t('common.last_name'),
                    sortable: true,
                },
                {
                    key: 'profile.name',
                    label: this.$t('management.profile'),
                    sortable: true,
                },
                {
                    key: 'first_choice',
                    label: this.$t('management.first_choice'),
                },
                {
                    key: 'second_choice',
                    label: this.$t('management.second_choice'),
                },
                {
                    key: 'third_choice',
                    label: this.$t('management.third_choice'),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
